import styled from 'styled-components';
import { css, breakpoints } from 'src/styles/theme';
import { WallboxSelectStyled } from '../WallboxSelectStyled';
import { rem } from 'polished';

export const WallboxSelectAC = styled(WallboxSelectStyled)`
    border-top: ${rem(1)} solid ${({ theme }) => theme.colors.grey16};

    .titleWrapper {
        .title {
            font-size: ${({ theme }) => theme.fontSizes.h2};
            color: ${({ theme }) => theme.colors.grey5};
        }
        .isClose {
            svg {
                path {
                    fill: ${({ theme }) => theme.colors.red};
                }
            }
        }
        .isOpen {
            svg {
                path {
                    stroke: ${({ theme }) => theme.colors.red};
                }
            }
        }
    }
`;
